const getters = {
  publicPlans: (state) => state.publicPlans,
  adminPlans: (state) => state.adminPlans,
  activePlans: (state) => state.adminPlans.filter((p) => p.is_active !== false),
};

export default getters;
